import { useBoolean } from 'minimal-shared/hooks'
import { useRef, useEffect, useCallback } from 'react'
import { isActiveLink, isExternalLink } from 'minimal-shared/utils'

import { usePathname } from 'src/routes/hooks'

import { NavItem } from './nav-item'
import { navSectionClasses } from '../styles'
import { NavLi } from '../components'

// ----------------------------------------------------------------------

export function NavList({
  data,
  depth,
  render,
  slotProps,
  enabledRootRedirect
}) {
  const pathname = usePathname()
  const navItemRef = useRef(null)

  const isActive = isActiveLink(pathname, data.path, !!data.children)

  const { value: open, onFalse: onClose, onToggle } = useBoolean(isActive)

  useEffect(() => {
    if (!isActive) {
      onClose()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname])

  const handleToggleMenu = useCallback(() => {
    if (data.children) {
      onToggle()
    }
  }, [data.children, onToggle])

  const renderNavItem = () => (
    <NavItem
      ref={navItemRef}
      // slots
      path={data.path}
      onClickNav={data.onClickNav}
      icon={data.icon}
      info={data.info}
      title={data.title}
      caption={data.caption}
      // state
      open={open}
      active={isActive}
      disabled={data.disabled}
      // options
      depth={depth}
      render={render}
      hasChild={!!data.children}
      externalLink={data.external || isExternalLink(data.path)}
      enabledRootRedirect={enabledRootRedirect}
      // styles
      slotProps={depth === 1 ? slotProps?.rootItem : slotProps?.subItem}
      // actions
      onClick={handleToggleMenu}
    />
  )

  // const renderCollapse = () =>
  //   !!data.children && (
  //     <NavCollapse
  //       mountOnEnter
  //       unmountOnExit
  //       depth={depth}
  //       in={open}
  //       data-group={data.title}
  //     >
  //       <NavSubList
  //         data={data.children}
  //         render={render}
  //         depth={depth}
  //         slotProps={slotProps}
  //         enabledRootRedirect={enabledRootRedirect}
  //       />
  //     </NavCollapse>
  //   )

  return (
    <NavLi
      disabled={data.disabled}
      sx={{
        ...(!!data.children && {
          [`& .${navSectionClasses.li}`]: {
            '&:first-of-type': { mt: 'var(--nav-item-gap)' }
          }
        })
      }}
    >
      {renderNavItem()}
      {/* {renderCollapse()} */}
    </NavLi>
  )
}

// function NavSubList({
//   data,
//   render,
//   depth = 0,
//   slotProps,
//   enabledRootRedirect
// }) {
//   return (
//     <NavUl sx={{ gap: 'var(--nav-item-gap)' }}>
//       {data.map((list) => (
//         <NavList
//           key={list.title}
//           data={list}
//           render={render}
//           depth={depth + 1}
//           slotProps={slotProps}
//           enabledRootRedirect={enabledRootRedirect}
//         />
//       ))}
//     </NavUl>
//   )
// }
